__turbopack_context__.v({
  "accordionSlideOverwrite": "tooltip-module-scss-module__DrpiBq__accordionSlideOverwrite",
  "fadeIn": "tooltip-module-scss-module__DrpiBq__fadeIn",
  "fadeOut": "tooltip-module-scss-module__DrpiBq__fadeOut",
  "scaleIn": "tooltip-module-scss-module__DrpiBq__scaleIn",
  "scaleOut": "tooltip-module-scss-module__DrpiBq__scaleOut",
  "storybookContainer": "tooltip-module-scss-module__DrpiBq__storybookContainer",
  "tooltip": "tooltip-module-scss-module__DrpiBq__tooltip",
  "tooltipArrowPrimary": "tooltip-module-scss-module__DrpiBq__tooltipArrowPrimary",
  "tooltipArrowSecondary": "tooltip-module-scss-module__DrpiBq__tooltipArrowSecondary",
  "tooltipContent": "tooltip-module-scss-module__DrpiBq__tooltipContent",
  "tooltipLarge": "tooltip-module-scss-module__DrpiBq__tooltipLarge",
  "tooltipPrimary": "tooltip-module-scss-module__DrpiBq__tooltipPrimary",
  "tooltipSecondary": "tooltip-module-scss-module__DrpiBq__tooltipSecondary",
  "tooltipSmall": "tooltip-module-scss-module__DrpiBq__tooltipSmall",
  "zoomIn": "tooltip-module-scss-module__DrpiBq__zoomIn",
  "zoomOut": "tooltip-module-scss-module__DrpiBq__zoomOut",
});
